<template>
  <a
    v-if="hasValue"
    class="btn btn-sm"
    @click="copy"
  >
    <i class="far fa-copy"></i>
  </a>
</template>

<script>
import uiHelperMixin from "@/mixins/uiHelper";

export default {
  name: 'CopyButton',
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  mixins: [uiHelperMixin],
  computed: {
    hasValue() {
      return this.value !== null && this.value !== undefined && this.value !== '';
    }
  },
  methods: {
    copy() {
      this.copyToClipboard(String(this.value));
    }
  }
}
</script>
